export enum PokerDealtTo {
    PLAYER_1 = 'player_1',
    PLAYER_2 = 'player_2',
    PLAYER_3 = 'player_3',
    PLAYER_4 = 'player_4',
    PLAYER_5 = 'player_5',
    PLAYER_6 = 'player_6',
    BOARD = 'board',
}
